var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cube-parallax1',{attrs:{"backgroundImageUrl":_vm.backgroundImageUrl,"backgroundColor":_vm.backgroundColor,"textColor":_vm.textColor,"backgroundText":_vm.backgroundText,"mainText":_vm.mainText,"subText":_vm.subText}})}
var staticRenderFns = []

export { render, staticRenderFns }